<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
            [request]="getRequest"
            [filtering]="filtering"
            [cols]="cols"
            [globalConditionalStyle]="globalConditionalStyle"
            [globalVisualTransform]="globalVisualTransform"
            actionButtonText="Añadir Piscina"
            (emitSearchText)="updateFooter()"
            (actionButtonClick)="add()">
            <ng-template #header>
                 <div class="d-flex gap-4 flex-row align-self-end m-0 text-black">
                    <div class="d-flex flex-column justify-content-center align-content-center p-0 m-0">
                        <label>Realizados</label>
                        <p-selectbutton [options]="optionsSelectButton" optionLabel="label" optionValue="value" (onChange)="filtrar()"
                            [(ngModel)]="realizadoSelectButton" aria-labelledby="basic">
                        </p-selectbutton>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-content-center p-0 m-0">
                        <label class="bagde" for="f_Init">F.Inicio</label>
                        <app-datepicker id="f_Init" (sendFecha)="getFechaInicio($event)" />
                    </div>
                    <div class="d-flex flex-column justify-content-center align-content-center p-0 m-0" style="margin-left: 20px;">
                        <label class="bagde" for="f_Fin">F.Fin</label>
                        <app-datepicker id="f_Fin" (sendFecha)="getFechaFin($event)" />
                    </div>
                    <button class="align-self-center mx-2 btn" (click)="downloadCsv()"
                        style="font-size: .8rem; background-color: #16A2B7; color: white">
                        <i class="fa fa-download"></i>
                        Exportar listado
                    </button>
                </div>
            </ng-template>
        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center"
                   style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data>
            <td>
                <app-action-buttons
                        [hideDelete]="hiddenButtonDelete" [showDuplicate]="true"
                        (duplicateRowButtonEvent)="duplicate(data.data)"
                        (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)"
                        (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>

        <ng-template #footer let-col>
            <div style="font-size: 0.75em; text-align: left" *ngIf="(['cliente_nombre'].includes(col.field))">
              TOTAL:
            </div>
            <div *ngIf="(['horas_totales'].includes(col.field))"
              style="font-size: 0.75em; text-align: right; font-weight: bold; padding-right: 34px">
              {{this.totalHoras  || 0}}
            </div>
        </ng-template>
        
    </app-common-list-table>
</div>

<p-dialog
    *ngIf="canShow['info']"
    header="Detalle del registro"
    [(visible)]="canShow['info']"
    (onShow)="scrollToTop()">

    <div style="width: 80vw !important">
        <div style="display: flex;justify-content: space-between;">
                <h4>Datos de piscina</h4>
               
            </div>
        <app-form-builder
                [fields]="formFields"
                [distributionColumns]="2"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h4>Tareas</h4>
        <app-form-builder
                [fields]="formFieldsTareas01"
                [distributionColumns]="2"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Comprobar Parámetros</h5>
        <app-form-builder
                [fields]="formFieldsTareas02"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Otras Tareas</h5>
        <app-form-builder
                [fields]="formFieldsTareas03"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h4>Productos</h4>
        <h5>Cloro</h5>
        <app-form-builder
                [fields]="formFieldsProductos01"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Floculante</h5>
        <app-form-builder
                [fields]="formFieldsProductos02"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Otros Productos</h5>
        <app-form-builder
                [fields]="formFieldsProductos03"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h4>Recambios</h4>
        <app-form-builder
                [fields]="formFieldsRecambios"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <app-form-builder
                [fields]="formFieldsTrabajadores"
                [distributionColumns]="3"
                [distributionOrder]="[3]"
                [model]="model">
        </app-form-builder>
        <div class="row">
            <div class="col-lg-6">
                <app-form-builder
                [model]="model"
                [distributionColumns]="1" 
                [fields]="formFieldsObs">
            </app-form-builder>  
            </div>
            <div class="col-lg-6">
                <div style="display: flex;justify-content: space-between;">
                    <app-upload-images 
                    [model]="model" 
                    folder="piscinas" 
                    tipo="list" 
                    ></app-upload-images>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <app-form-builder
                [model]="model"
                [distributionColumns]="1" 
                [fields]="formFieldsOrdenTrabajo">
            </app-form-builder>  
            </div>
            <div class="col-lg-6">
                <div style="display: flex;justify-content: space-between;">
                    <app-upload-images 
                    [model]="model" 
                    folder="piscinas" 
                    tipo="list"
                    nombre_imagen = 'image_after'  
                    ></app-upload-images>
                </div>
            </div>
        </div>
        <div>
        <div *ngIf="this.model['signature_img']" style="display: flex; flex-direction: column;">
                <p>Firma</p>
                <img [src]="serverUrl + 'images/mto_piscinas/'+this.model.signature_img " class="info-firma-img" alt="Firma">
            </div>
        </div>                
        <div class="d-flex justify-content-center" style="margin-top: 40px">
            <button class="btn btn-dark mx-2" (click)="hide('info')">Cerrar</button>
        </div>
    </div>
    <br>

</p-dialog>

<p-dialog
    *ngIf="canShow['delete']"
    header="Eliminar registro"
    [(visible)]="canShow['delete']"
    (onShow)="scrollToTop()">

    <div style="width: 80vw !important">
        <div style="display: flex;justify-content: space-between;">
                <h4>Datos de piscina</h4>
           
            </div>
        <app-form-builder
                [fields]="formFields"
                [distributionColumns]="2"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h4>Tareas</h4>
        <app-form-builder
                [fields]="formFieldsTareas01"
                [distributionColumns]="2"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Comprobar Parámetros</h5>
        <app-form-builder
                [fields]="formFieldsTareas02"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Otras Tareas</h5>
        <app-form-builder
                [fields]="formFieldsTareas03"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h4>Productos</h4>
        <h5>Cloro</h5>
        <app-form-builder
                [fields]="formFieldsProductos01"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Floculante</h5>
        <app-form-builder
                [fields]="formFieldsProductos02"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h5>Otros Productos</h5>
        <app-form-builder
                [fields]="formFieldsProductos03"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <h4>Recambios</h4>
        <app-form-builder
                [fields]="formFieldsRecambios"
                [distributionColumns]="3"
                [distributionOrder]="distributionOrder"
                [model]="model">
        </app-form-builder>
        <app-form-builder
                [fields]="formFieldsTrabajadores"
                [distributionColumns]="3"
                [distributionOrder]="[3]"
                [model]="model">
        </app-form-builder>
        <app-form-builder
                [fields]="formFieldsObs"
                [distributionColumns]="2"
                [distributionOrder]="[2]"
                [model]="model">
        </app-form-builder>
        <br>
        <div style="display: flex; gap: 50px;margin-bottom: 100px; ">
                <div style="display: flex;justify-content: space-between;">
                    <app-upload-images 
                    [model]="model" 
                    folder="piscinas" 
                    tipo="list" 
                    ></app-upload-images>
                </div>
                <div style="display: flex;justify-content: space-between;">
            
                    <app-upload-images 
                    [model]="model" 
                    folder="piscinas" 
                    tipo="list"
                    nombre_imagen = 'image_after'  
                    ></app-upload-images>
                </div>
            </div>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="hide('delete')">Cerrar</button>
            <app-request-button
                    (click)="deleteRegister()"
                    [request]="deleteRequest"
                    [mode]="deleteRequestButtonType">
            </app-request-button>
        </div>
        <br>
        <p *ngIf="deleteRequest.hasError === undefined && !deleteRequest.isLoading"
           style="color: red; text-align: center">
            ¿Está seguro de eliminar este registro?
        </p>
    </div>
    <br>

</p-dialog>